import { ArgumentOutOfRangeException } from "../../shared/index.js";
import { BasicEnumerable } from "../BasicEnumerable.js";
export const repeat = (element, count) => {
    if (count < 0) {
        throw new ArgumentOutOfRangeException("count");
    }
    function* iterator() {
        for (let i = 0; i < count; i++) {
            yield element;
        }
    }
    return new BasicEnumerable(iterator);
};
